export default __webpack_public_path__ + "static/media/OpenSourceBank.47cc86c1.png";